import Vue from "vue";
export const EventsGlobal = new Vue();



// WEBPACK FOOTER //
// ./src/events/eventsGlobal.js